module.exports = __webpack_public_path__ + "static/media/flow-pl.9dfc2b60.png";